module.exports = __webpack_public_path__ + "img/logo_irma.1b60dc9a.png";